import React from 'react';
import moment from 'moment';
import addDurationCapability from 'moment-duration-format';

addDurationCapability(moment);

const DurationActual = ({ value, color, startedAt, endedAt, interpretationDate }) => {
  if (value === null || value === undefined) {
    return '';
  }
  const formattedDuration = moment.duration(value, 'seconds').format('hh:mm', { trim: false });

  // Resolve a window to display.
  //   1. Prefer real backend timestamps when both are present.
  //   2. Otherwise derive end = start + durationActual. Real logged start wins
  //      over the scheduled interpretationDate when both are available.
  let start = null;
  let end = null;
  if (startedAt && endedAt) {
    start = moment(startedAt);
    end = moment(endedAt);
  } else {
    const startSource = startedAt || interpretationDate;
    if (startSource) {
      start = moment(startSource);
      end = start.clone().add(value, 'seconds');
    }
  }

  if (start && end) {
    return (
      <span style={{ color, fontWeight: 'bold' }}>
        {start.format('HH:mm')} - {end.format('HH:mm')} ({formattedDuration})
      </span>
    );
  }

  return (
    <span style={{ color, fontWeight: 'bold' }}>
      {formattedDuration}
    </span>
  );
};

export default DurationActual;
